/**
 * Legal Document Versions
 * Centralized versioning for Terms, Privacy, Cookies, and DPA
 * 
 * When updating legal documents:
 * 1. Update the version here
 * 2. Update LAST_UPDATED date
 * 3. Users with older acceptedVersion will be re-prompted on next login
 */

export const LEGAL_VERSIONS = {
  terms: 'v1.0',
  privacy: 'v1.0',
  cookies: 'v1.0',
  dpa: 'v1.0'
};

export const LEGAL_LAST_UPDATED = {
  terms: 'December 2025',
  privacy: 'December 2025',
  cookies: 'December 2025',
  dpa: 'December 2025'
};

export const LEGAL_URLS = {
  terms: '/terms',
  privacy: '/privacy',
  cookies: '/cookies',
  dpa: '/dpa'
};

export const CANONICAL_DOMAIN = 'https://getfinlist.com';

/**
 * Check if user needs to re-accept terms
 * @param {string} acceptedVersion - Version user previously accepted
 * @param {string} documentType - 'terms' | 'privacy' | 'cookies' | 'dpa'
 * @returns {boolean} - true if user needs to re-accept
 */
export function needsReAcceptance(acceptedVersion, documentType) {
  if (!acceptedVersion) return true;
  const currentVersion = LEGAL_VERSIONS[documentType];
  if (!currentVersion) return false;
  return acceptedVersion !== currentVersion;
}

/**
 * Create acceptance metadata object for storing in user profile
 * @returns {Object} - Acceptance metadata
 */
export function createAcceptanceMetadata() {
  return {
    acceptedTerms: true,
    acceptedPrivacy: true,
    acceptedAt: new Date().toISOString(),
    termsVersion: LEGAL_VERSIONS.terms,
    privacyVersion: LEGAL_VERSIONS.privacy
  };
}
